import { render, staticRenderFns } from "./SuitableResourcesRequest.vue?vue&type=template&id=5a046248"
import script from "./SuitableResourcesRequest.vue?vue&type=script&lang=ts"
export * from "./SuitableResourcesRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a046248')) {
      api.createRecord('5a046248', component.options)
    } else {
      api.reload('5a046248', component.options)
    }
    module.hot.accept("./SuitableResourcesRequest.vue?vue&type=template&id=5a046248", function () {
      api.rerender('5a046248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/requests/SuitableResourcesRequest.vue"
export default component.exports